export default {
  factoryItems: [],
  factoryItem: undefined,
};
